/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
// ****** Third Party ****** //
import { useLocation } from "react-router-dom";
// ****** React Query & HTTP methods ****** //
import { page_config } from "../services/CommonServices/CommonServices";
import { useQuery } from "@tanstack/react-query";
// ****** Custom hooks ****** //
import useChartStore from "./useChartStore";


/**
 * A custom hook that fetches and manages navbar configuration based on the current URL path.
 * It determines the configuration key ("expert", "advanced", or "beginner") from the pathname
 * and retrieves the corresponding configuration data using a query.
 *
 * @returns {Object} An object containing the configuration data, error state, and loading state.
 * @returns {Object|undefined} return.configs - The fetched configuration data, including indicators.
 * @returns {boolean} return.isError - Indicates if an error occurred during the query.
 * @returns {boolean} return.isLoading - Indicates if the query is currently loading.
 */
const useNavbarConfig = () => {
  const { pathname } = useLocation();

  const { setChartIndicators } = useChartStore();

  const config_key = useMemo(() => {
    if (pathname.includes("expert")) return "expert";
    if (pathname.includes("advanced")) return "advanced";
    return "beginner";
  }, [pathname]);

  const {
    data: configs,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["signals", config_key],
    queryFn: () => page_config(config_key),
    enabled: !!pathname,
  });

  useEffect(() => {
    const excludes = configs?.data?.data?.indicators?.excludes;
    if (Array.isArray(excludes)) {
      setChartIndicators(excludes);
    }
  }, [configs]);

  return {
    configs,
    isError,
    isLoading,
  };
};

export default useNavbarConfig;
